import type { PreviewEvent } from "../../types";
import { TimeAgo } from "../time-ago";

export function TimelineItem({ event }: { event: PreviewEvent }) {
  const payload = event.payload;
  const message =
    typeof payload.message === "string"
      ? payload.message
      : typeof payload.error === "string"
        ? payload.error
        : typeof payload.phase === "string"
          ? payload.phase
          : typeof payload.reason === "string"
            ? payload.reason
            : "";
  const logTail = typeof payload.logTail === "string" ? payload.logTail : "";
  return (
    <li className="space-y-1 text-sm">
      <div className="flex flex-wrap items-baseline gap-2">
        <span className="font-mono text-xs text-muted-foreground">{event.type}</span>
        {message && <span>{message}</span>}
        <TimeAgo at={event.createdAt} className="ml-auto text-xs text-muted-foreground tabular-nums" />
      </div>
      {logTail && (
        <pre className="max-h-48 overflow-auto rounded-md bg-muted px-2 py-1.5 text-xs whitespace-pre-wrap">
          {logTail}
        </pre>
      )}
    </li>
  );
}
